export default "__VITE_ASSET__Cp$$UsJG__"